module.exports = __webpack_public_path__ + "img/stop_btn.11ea8134.png";